// extracted by mini-css-extract-plugin
var _1 = "NotificationsPopup_actionsWrapper__wRcwS";
var _2 = "NotificationsPopup_filter__+bsPe";
var _3 = "NotificationsPopup_header__X9C66";
var _4 = "NotificationsPopup_headerWrapper__jpZlg";
var _5 = "NotificationsPopup_noUnread__itYjN";
var _6 = "NotificationsPopup_notificationCount__kwprw";
var _7 = "NotificationsPopup_title__m7-QE";
var _8 = "NotificationsPopup_wrapper__a5zac";
export { _1 as "actionsWrapper", _2 as "filter", _3 as "header", _4 as "headerWrapper", _5 as "noUnread", _6 as "notificationCount", _7 as "title", _8 as "wrapper" }
